export default {
    syear: 116,
}